import { Outlet } from 'react-router'
import { Header } from './Header'
import Sidebar from '../Navigation/Sidebar'
import { ProductionDebug } from '../common/ProductionDebug'
import styles from '../../styles/layout.module.scss'

export default function MainLayout() {
  return (
    <>
      <Header />
      <div className={styles["main-content"]}>
        <Sidebar />
        <div className={styles["content"]}>
          <Outlet />
        </div>
      </div>
      <ProductionDebug />
    </>
  )
}
